
export type RemoteStateQueryPhase = 'none' | 'loading' | 'loaded' | 'error';

export const QuizSessionQuerySymbol = Symbol.for('QuizSessionQuery')

export type QuizSessionPhase = '' | 'active' | 'aborted' | 'finished'

export interface QuizSessionQuery {
  findSessionByQuizId(quizId: string,
                      aspect: string): false | { id: string, type: string, state: unknown }
  findSession(id: string): false | { id: string, type: string, phase: QuizSessionPhase, state: unknown }
  remotePhase: RemoteStateQueryPhase;
}
